
export type TrackMetricRequestTags = {[key: string]: string};
